require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-e-ycc-l.json") })
        }
      }, "path---photos-professional-e-ycc-l");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-e-ycc-l!./.cache/json/photos-professional-e-ycc-l.json
// module id = 741
// module chunks = 231608221292675